import { IsiDtoPlDiagHeaderRequest, IsiDtoPlDiagHeaderResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlDiagHeader";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlDiagHeader extends IsiPresentationLogic {

    constructor() {
        super("IsiPlDiagHeaderHandler");
    }

    public async LoadDiagHeader(type: string): Promise<string> {
        let params = IsiDtoPlDiagHeaderRequest.fromJS({
            type: type,
            response: IsiDtoPlDiagHeaderResponse.fromJS({
            })
        });;

        const result: IIsiUIFlowResultGeneric<IsiDtoPlDiagHeaderRequest> = await this.ajaxWithErrorHandling("LoadDiagHeader", params, true);

        return result?.reponse?.response?.getDiagHeaderResult.diagHeaderStrResult;
        
    }


}